import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { cueArrowRight, IconComponent } from '@cue/ui/icons';
import { LocalizedStringPipe } from '@cue/utilities';
import { LocalizedString } from '@cue/api';

type NavigationBreadcrumbInfo = {
  areaId: number;
  breadcrumbWithIds: {
    name?: LocalizedString;
    areaId?: number;
    item1?: number;
    item2?: string;
  }[];
}[];

@Component({
  selector: 'cue-navigation-breadcrumb',
  imports: [IconComponent, LocalizedStringPipe],
  templateUrl: './navigation-breadcrumb.component.html',
  styleUrl: './navigation-breadcrumb.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationBreadcrumbComponent {
  areaClicked = output<number>();

  areaInfos = input.required<NavigationBreadcrumbInfo>();
  areaId = input<number>();

  ICONS = {
    cueArrowRight,
  };

  selectedAreaBreadcrumb = computed(() => {
    if (!this.areaInfos()?.length || this.areaId() === null) {
      return [];
    }
    const breadcrumbList = this.areaInfos().find((x) => x.areaId == this.areaId()).breadcrumbWithIds;

    return breadcrumbList.map((x, index) => {
      return {
        name: x.name ?? x.item2,
        areaId: x.areaId ?? x.item1,
        active: (x.areaId ?? x.item1) == this.areaId(),
      };
    });
  });
}
